// src/services/cierreGeneralService.js

/**
 * Cierre General Service (Opción B real)
 * - Usa REACT_APP_API_BASE_URL si existe (recomendado).
 * - Si NO existe, usa un fallback FIJO (FORCED_BACKEND_BASE).
 *
 * ❗️NO usa window.location.origin como fallback porque en tu caso
 * eso pega al frontend y devuelve index.html (HTML) en vez del JSON.
 */

// 1) Base desde .env (se inyecta al compilar)
const ENV_BASE = process.env.REACT_APP_API_BASE_URL?.replace(/\/$/, '');

// 2) ✅ FALLBACK FIJO (CAMBIÁ ESTO por tu API pública real)
const FORCED_BACKEND_BASE = 'https://api.floristeria2000.com';

// 3) Base final
const API_BASE = ENV_BASE || FORCED_BACKEND_BASE;

const CG_TOKEN_KEY = 'cierre_general_token';

async function safeJson(res) {
  const text = await res.text();
  try {
    return { json: JSON.parse(text), raw: text };
  } catch {
    return { json: null, raw: text };
  }
}

const cierreGeneralService = {
  setToken(token) {
    if (typeof token === 'string' && token.trim()) {
      localStorage.setItem(CG_TOKEN_KEY, token.trim());
    }
  },

  getToken() {
    return localStorage.getItem(CG_TOKEN_KEY);
  },

  clearToken() {
    localStorage.removeItem(CG_TOKEN_KEY);
  },

  /**
   * POST /api/cierre-general/access/verify
   * body: { code: "1970" }
   * response: { ok:true, cgToken:"..." }
   */
  async verifyAccess(code) {
    const url = `${API_BASE}/api/cierre-general/access/verify`;

    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ code: String(code || '').trim() }),
    });

    const { json, raw } = await safeJson(res);

    // Logs útiles (podés dejarlos o quitarlos luego)
    console.log('[CierreGeneral] verifyAccess URL:', url);
    console.log('[CierreGeneral] verifyAccess status:', res.status);
    console.log('[CierreGeneral] verifyAccess response json:', json);
    console.log('[CierreGeneral] verifyAccess response raw:', raw?.slice(0, 200));

    if (!res.ok) {
      const msg =
        json?.message ||
        json?.error ||
        `ACCESO DENEGADO (HTTP ${res.status})`;
      throw new Error(msg);
    }

    if (!json?.cgToken) {
      // Si te pasa esto, casi siempre estás pegando a un server que devuelve HTML
      throw new Error('El servidor no devolvió token de acceso.');
    }

    this.setToken(json.cgToken);
    return json;
  },

  /**
   * GET /api/cierre-general/dashboard?start=YYYY-MM-DD&end=YYYY-MM-DD
   * headers: x-cierre-general-token
   */
  async getDashboard({ start, end }) {
    const token = this.getToken();
    if (!token) throw new Error('ACCESO DENEGADO');

    const qs = new URLSearchParams({ start, end }).toString();
    const url = `${API_BASE}/api/cierre-general/dashboard?${qs}`;

    const res = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'x-cierre-general-token': token,
      },
    });

    const { json, raw } = await safeJson(res);

    console.log('[CierreGeneral] getDashboard URL:', url);
    console.log('[CierreGeneral] getDashboard status:', res.status);
    console.log('[CierreGeneral] getDashboard response json:', json);
    console.log('[CierreGeneral] getDashboard response raw:', raw?.slice(0, 200));

    if (!res.ok) {
      const msg =
        json?.message ||
        json?.error ||
        `Error al cargar Cierre General (HTTP ${res.status})`;

      // Si es 401, token inválido: limpiamos para forzar pedir código de nuevo
      if (res.status === 401) {
        this.clearToken();
      }

      throw new Error(msg);
    }

    if (!json) {
      throw new Error('Respuesta inválida del servidor.');
    }

    return json;
  },
};

export default cierreGeneralService;
